/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import AuthenticationGroupList from "../../../../components/Administrations/AccessControls/Authentication/AuthenticationGroupList";
import { OPERATIONTYPES } from "../../../../globals/constants";
import { useGetExternalAuthenticationQuery } from "../../../../store/api/deviceConfig/deviceConfigApiSlice";

const Authentication: React.FC = () => {
  useGetExternalAuthenticationQuery({ actionType: OPERATIONTYPES.GETGENERALAUTH });
  useGetExternalAuthenticationQuery({ actionType: OPERATIONTYPES.GETRADIUS });
  useGetExternalAuthenticationQuery({ actionType: OPERATIONTYPES.GETTACACS });
  useGetExternalAuthenticationQuery({ actionType: OPERATIONTYPES.GETSAML });
  return <AuthenticationGroupList />;
};

export default Authentication;
